// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__q_qjV","fileBtn":"File_fileBtn__27Kzx","closeBtn":"File_closeBtn__JoyqB","fileSelected":"File_fileSelected__2wUQ4","disabled":"File_disabled__18Cuu"};